/**
 * Shared progress bar styles for WaitScreen components
 * Used across all AI loading screens to display course generation progress
 */

export const PROGRESS_BAR_STYLES = `
  .wait-screen-progress-container {
    position: relative;
    width: 100%;
    max-width: 62rem;
    z-index: 10;
    margin-bottom: 0.25rem;
  }

  .wait-screen-progress-row {
    display: flex;
    align-items: center;
    gap: 0.625rem;
  }

  .wait-screen-progress-percent {
    font-size: 0.875rem;
    font-weight: 600;
    color: #334155;
    min-width: 2.5rem;
    text-align: right;
  }

  .wait-screen-progress-track {
    flex: 1;
    height: 0.625rem;
    border-radius: 9999px;
    background-color: #e2e8f0;
    overflow: hidden;
  }

  .wait-screen-progress-fill {
    height: 100%;
    border-radius: inherit;
    background: #015ffb;
    transition: width 280ms linear;
  }

  .wait-screen-card {
    padding-top: 0.5rem !important;
  }

  .wait-screen-card-content {
    gap: 0.75rem !important;
  }

  .wait-screen-title-container {
    padding: 0.125rem 0.5rem 0 !important;
  }

  @media (max-width: 640px) {
    .wait-screen-progress-container {
      margin-bottom: 0.25rem;
    }

    .wait-screen-progress-percent {
      font-size: 0.8125rem;
    }
  }
`
